import React, { FC } from "react";
import { usePathname, useRouter } from "next/navigation";
import classNames from "classnames";

import { ISidebarMenuItem } from "../utils/sidebarMenuItems";
import { useTranslations } from "next-intl";

type Props = {
  item: ISidebarMenuItem;
  lessOpacity?: boolean;
};

const SidebarMenuListItem: FC<Props> = ({ item, lessOpacity }) => {
  const pathname = usePathname();
  const isActive = pathname.includes(item.href);
  const router = useRouter();

  const t = useTranslations();

  const Icon = item.icon;

  return (
    <li
      className={classNames(
        "2xxl:py-4 mb-1 cursor-pointer rounded-[32px] px-6 py-3",
        {
          "primary-color active-bg-color": isActive,
          "text-white": !isActive,
          "opacity-60": !!lessOpacity && !isActive,
        },
      )}
      onClick={() => router.push(item.href)}
    >
      <div className="flex items-center gap-2">
        <Icon />
        <span>{t(item.title)}</span>
      </div>
    </li>
  );
};

export default SidebarMenuListItem;
